import { H6, LI, P, UL } from "../../../AbstractElements";
import { FileListPropsType } from "../../../Type/FileManagerType";

const FileList = ({ myFile }: FileListPropsType) => {
  return (
    <UL className="simple-list d-flex flex-row files-content">
      {myFile.map((data, i) => (
        <LI key={i} className="folder-box d-flex align-items-center">
          <div className="d-flex align-items-center files-list">
            <div className="flex-shrink-0 file-left"><i className={data.icon}></i></div>
            <div className="flex-grow-1 ms-3">
              <H6>{data.name}</H6>
              <P className="mb-1">{data.modify}{data.size}</P>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
};

export default FileList;
